<footer class="cmx-footer" *ngIf="version !== 3">
  <p
    class="cmx-footer__copyright"
    [innerHtml]="layout.footerLabel | async"
    (click)="layout.footerLabelClick.emit()"
  ></p>
  <ng-container *ngIf="layout.directionSwitcher | async">
    <app-switch (select)="onSelect($event)"></app-switch>
  </ng-container>
  <ul class="cmx-footer__menu">
    <li
      *ngFor="let link of layout.footerLinks | async"
      (click)="layout.footerLinkClick.emit(link.id)"
      class="cmx-footer__menu-item"
    >
      {{ link.label }}
    </li>
  </ul>
</footer>
